module.exports = __webpack_public_path__ + "media/images/homepage/slider2-397fa51ae434e36c281ce28b61535152.svg";